import { json } from 'd3-fetch';
var baseUrl = 'https://cdn.jsdelivr.net/npm/@keen.io/dataviz-maps@latest/maps';
export var fetchMapTopology = function (map) { return json(baseUrl + "/" + map + ".json"); };
